var heading_default = {
  "fontElementMap": "KDHhV",
  "elementSpacing": "KcWqD",
  "headerOne": "_67vtb KcWqD",
  "headerTwo": "mgtTd KcWqD",
  "headerThree": "D62Fw KcWqD",
  "headerFour": "mVtM3 KcWqD",
  "headerFive": "dQI4B KcWqD",
  "headerSix": "dxbZY KcWqD",
  "child": "HyTJE"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
